export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6636.b1656a07.jpg";